var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagDe = function SvgFlagDe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Flag_DE_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Flag_DE_svg__b",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Flag_DE_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48 0H0v17.114h48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE0000",
    d: "M48 17.113H0v14.613h48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF00",
    d: "M48 31.727H0V48h48z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Flag_DE_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgFlagDe;